(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pawkivo-routine-mobile"] && !Shopify.designMode) return;
  try {
    (() => {
    const mobileQuery = window.matchMedia('(max-width: 989px)');

    const imageUrlAtWidth = (source, width) => {
      const url = new URL(source, window.location.origin);
      url.searchParams.set('width', width);
      return url.toString();
    };

    const getImageSource = (image) => image.dataset.src || image.getAttribute('src');

    const hydrateImage = (image, sizes) => {
      const source = getImageSource(image);
      if (!source || image.dataset.hydrated === 'true') return;

      image.sizes = sizes;
      image.srcset = [720, 960, 1200, 1600]
        .map((width) => `${imageUrlAtWidth(source, width)} ${width}w`)
        .join(', ');
      image.src = imageUrlAtWidth(source, 1200);
      image.decoding = 'async';
      image.dataset.hydrated = 'true';
    };

    const hydrateDesktopImages = (section) => {
      const media = section.querySelector('.pk-routine-media');
      const items = section.querySelectorAll('.pk-routine-item');
      if (!media || !items.length) return;

      const findImage = (key) =>
        Array.from(media.querySelectorAll('[data-pk-image]')).find(
          (image) => image.getAttribute('data-pk-image') === key
        );

      hydrateImage(findImage('default'), '55vw');

      items.forEach((item) => {
        if (item.dataset.pkImageHydrationBound === 'true') return;

        const hydrateTarget = () => {
          hydrateImage(findImage(item.getAttribute('data-pk-target')), '55vw');
        };

        item.addEventListener('pointerenter', hydrateTarget, { passive: true });
        item.addEventListener('focus', hydrateTarget);
        item.addEventListener('click', hydrateTarget);
        item.dataset.pkImageHydrationBound = 'true';
      });
    };

    const buildMobileList = (section) => {
      if (section.querySelector('.pk-routine-mobile-list')) return;

      const sourceList = section.querySelector('.pk-routine-list');
      const media = section.querySelector('.pk-routine-media');
      const items = section.querySelectorAll('.pk-routine-item');

      if (!sourceList || !media || !items.length) return;

      const mobileList = document.createElement('div');
      mobileList.className = 'pk-routine-mobile-list';

      items.forEach((item) => {
        const key = item.getAttribute('data-pk-target');
        const number = item.querySelector('.pk-routine-number');
        const title = item.querySelector('.pk-routine-copy strong');
        const description = item.querySelector('.pk-routine-copy span');
        const sourceImage = Array.from(media.querySelectorAll('[data-pk-image]')).find(
          (image) => image.getAttribute('data-pk-image') === key
        );

        if (!number || !title || !description || !sourceImage) return;

        const block = document.createElement('article');
        block.className = 'pk-routine-mobile-block';

        const heading = document.createElement('div');
        heading.className = 'pk-routine-mobile-heading';
        heading.append(number.cloneNode(true));

        const copy = document.createElement('div');
        copy.className = 'pk-routine-mobile-copy';

        const blockTitle = document.createElement('h3');
        blockTitle.textContent = title.textContent;

        const blockDescription = document.createElement('p');
        blockDescription.textContent = description.textContent;

        copy.append(blockTitle, blockDescription);
        heading.append(copy);

        const image = sourceImage.cloneNode(false);
        const source = getImageSource(sourceImage);
        if (!source) return;
        image.className = 'pk-routine-mobile-image';
        image.removeAttribute('data-pk-image');
        image.loading = 'lazy';
        image.decoding = 'async';
        image.sizes = '(max-width: 640px) calc(100vw - 36px), calc(100vw - 44px)';
        image.srcset = [480, 720, 960, 1200, 1600]
          .map((width) => `${imageUrlAtWidth(source, width)} ${width}w`)
          .join(', ');
        image.src = imageUrlAtWidth(source, 960);

        block.append(heading, image);
        mobileList.append(block);
      });

      if (!mobileList.children.length) return;

      sourceList.insertAdjacentElement('afterend', mobileList);
      section.classList.add('pk-routine-mobile-static');
    };

    const removeMobileList = (section) => {
      section.querySelector('.pk-routine-mobile-list')?.remove();
      section.classList.remove('pk-routine-mobile-static');
    };

    const updateLayout = () => {
      document.querySelectorAll('[data-pk-routine]').forEach((section) => {
        if (mobileQuery.matches) {
          buildMobileList(section);
        } else {
          removeMobileList(section);
          hydrateDesktopImages(section);
        }
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', updateLayout, { once: true });
    } else {
      updateLayout();
    }

    mobileQuery.addEventListener('change', updateLayout);
    document.addEventListener('shopify:section:load', updateLayout);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-demo-video"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-demo-video')) {
    customElements.define(
      'product-demo-video',
      class ProductDemoVideo extends HTMLElement {
        connectedCallback() {
          this.video = this.querySelector('video');
          this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

          if (!this.video) return;

          this.pageReady = false;
          this.nearViewport = false;
          this.visible = false;
          this.videoLoadStarted = false;

          this.loadObserver = new IntersectionObserver(
            ([entry]) => {
              this.nearViewport = entry.isIntersecting;

              if (this.pageReady && this.nearViewport) {
                this.startVideoLoad();
              }
            },
            { rootMargin: '600px 0px', threshold: 0.01 }
          );

          this.playObserver = new IntersectionObserver(
            ([entry]) => {
              this.visible = entry.isIntersecting;
              this.updatePlayback();
            },
            { threshold: 0.35 }
          );

          this.handleVisibilityChange = () => {
            this.updatePlayback();
          };

          this.handlePageLoad = () => {
            this.waitForPriorityImage().then(() => {
              if (!this.isConnected) return;

              this.pageReady = true;
              if (this.nearViewport) {
                this.startVideoLoad();
              }
            });
          };

          this.loadObserver.observe(this);
          this.playObserver.observe(this);
          document.addEventListener('visibilitychange', this.handleVisibilityChange);

          if (document.readyState === 'complete') {
            this.handlePageLoad();
          } else {
            window.addEventListener('load', this.handlePageLoad, { once: true });
          }
        }

        waitForPriorityImage() {
          const productSection = this.closest('[id^="MainProduct-"]');
          const priorityImage = productSection?.querySelector(
            '.product__media-item.active img[fetchpriority="high"], .product__media-item.active img'
          );

          if (!priorityImage || priorityImage.complete) {
            return Promise.resolve();
          }

          return new Promise((resolve) => {
            priorityImage.addEventListener('load', resolve, { once: true });
            priorityImage.addEventListener('error', resolve, { once: true });
          });
        }

        startVideoLoad() {
          if (this.videoLoadStarted) return;

          this.videoLoadStarted = true;
          this.video.preload = 'metadata';
          this.video.load();
          this.loadObserver?.disconnect();
          this.updatePlayback();
        }

        updatePlayback() {
          const shouldPlay =
            this.videoLoadStarted &&
            this.visible &&
            document.visibilityState === 'visible' &&
            !this.reducedMotion.matches;

          if (shouldPlay) {
            this.video.play().catch(() => {});
          } else {
            this.video.pause();
          }
        }

        disconnectedCallback() {
          this.loadObserver?.disconnect();
          this.playObserver?.disconnect();
          window.removeEventListener('load', this.handlePageLoad);
          document.removeEventListener('visibilitychange', this.handleVisibilityChange);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-name-patch"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('name-patch-field')) {
    customElements.define(
      'name-patch-field',
      class NamePatchField extends HTMLElement {
        connectedCallback() {
          const input = this.querySelector('[data-name-patch-input]');
          const property = this.querySelector('[data-name-patch-property]');
          const count = this.querySelector('[data-name-patch-count]');
          const modeInputs = [...this.querySelectorAll('[data-name-patch-mode]')];
          const sameTextMode = this.querySelector('[data-name-patch-mode][value="same"]');
          const secondField = this.querySelector('[data-name-patch-second-field]');
          const secondInput = this.querySelector('[data-name-patch-second-input]');
          const secondProperty = this.querySelector('[data-name-patch-second-property]');
          const secondCount = this.querySelector('[data-name-patch-second-count]');

          if (!input || !property) return;

          const normalizeValue = (field) => {
            const maxLength = Number(field.maxLength) || 20;
            const value = field.value.slice(0, maxLength);
            field.value = value;
            return value;
          };

          const syncSecondValue = () => {
            if (!sameTextMode || !secondInput || !secondProperty) return;

            const secondValue = sameTextMode.checked ? property.value : normalizeValue(secondInput);
            secondProperty.value = secondValue || secondProperty.dataset.blankValue;

            if (secondCount) {
              const visibleValue = sameTextMode.checked ? input.value : secondInput.value;
              secondCount.textContent = `${visibleValue.length} / ${secondInput.maxLength}`;
            }
          };

          const syncMode = () => {
            if (!sameTextMode || !secondField || !secondInput) return;

            secondField.hidden = sameTextMode.checked;
            secondInput.disabled = sameTextMode.checked;
            syncSecondValue();
          };

          const syncValue = () => {
            const value = normalizeValue(input);
            property.value = value || property.dataset.blankValue;

            if (count) count.textContent = `${value.length} / ${input.maxLength}`;
            syncSecondValue();
          };

          input.addEventListener('input', syncValue);
          if (secondInput) secondInput.addEventListener('input', syncSecondValue);
          modeInputs.forEach((modeInput) => modeInput.addEventListener('change', syncMode));
          this.handlePageShow = syncMode;
          window.addEventListener('pageshow', this.handlePageShow);
          syncMode();
          syncValue();
        }

        disconnectedCallback() {
          if (this.handlePageShow) {
            window.removeEventListener('pageshow', this.handlePageShow);
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
